// External Libraries
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// UI Components
import FormField from '../../components/ui/FormField';
import SelectBox from '../../components/ui/SelectBox';
import CheckboxField from '../../components/ui/CheckboxField';
import SubmitButton from '../../components/ui/SubmitButton';

// Redux Actions
import { getCitiesFunc } from '../../../store/custom-actions/cities-actions/GetCitiesSlicer';
import { updateCityFunc } from '../../../store/custom-actions/cities-actions/UpdateCitySlicer';
import { getCountriesFunc } from '../../../store/custom-actions/countries-actions/GetContriesSlicer';
import { getStatesFunc } from '../../../store/custom-actions/states-actions/GetStatesSlicer';


function UpdateCityForm({ show, onHide, city  }) {
    const { t } = useTranslation(); // Initialize translation hook
    const dispatch = useDispatch();

    const { register, reset, formState: { errors }, handleSubmit, setValue, watch } = useForm();


    const countryId = watch("country_id");
    const [countriesList, setCountriesList] = useState([]);
    const [statesList, setStatesList] = useState([]);

    const { loading: getCountriesLoading, data: countriesData } = useSelector(state => state.getCountriesSlicer);
    const { loading: getStatesLoading, data: statesData } = useSelector(state => state.getStatesSlicer);
    const { loading: submitLoading } = useSelector(state => state.updateCitySlicer);

useEffect(() => {
  if (city) {
    setValue("name", city.name);
    setValue("code", city.code);
    setValue("country_id", city.country_id);
    setValue("state_id", city.state_id);
    setValue("active", city.active);
  }
}, [city, setValue]);

    useEffect(() => {
        const getCitites = async () => {
            try {
                dispatch(getCountriesFunc());
            } catch (error) {
                console.log(error);
            }
        };
        getCitites();
    }, []);

    useEffect(() => {
        countriesData && setCountriesList(countriesData);
    }, [countriesData]);

    useEffect(() => {
        if (countryId) {
            setValue("state_id", "");
            dispatch(getStatesFunc(`?country_id=${countryId}`));
        }
    }, [countryId]);


    useEffect(() => {
        statesData && setStatesList(statesData);
        setValue("state_id", city.state_id);
    }, [statesData]);

    const resetForm = () => {
        reset();
        onHide();
    };

    const onSubmit = async (data) => {
        const payload = { ...data };
        const result = await dispatch(updateCityFunc({
            id: city.id,
            data: payload
        }));
        if (updateCityFunc.fulfilled.match(result)) {
            dispatch(getCitiesFunc());
            resetForm();
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide}>
                <Modal.Header>
                    <Modal.Title>{t('Update')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form
                        id="submit-form-update"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <FormField
                            label="Name"
                            name="name"
                            register={register}
                            required={true}
                            errors={errors}
                        />

                        <FormField
                            label="Code"
                            name="code"
                            register={register}
                            required={true}
                            errors={errors}
                        />
                        <div className='mb-3'>
                            <SelectBox
                                label={t("Country")}
                                showLabel={true}
                                name="country_id"
                                register={register}
                                data={countriesList}
                                loading={getCountriesLoading}
                                placeholder={t("Choose Country")}
                                required={true}
                                errors={errors}
                            />
                        </div>
                        <div className='mb-3'>
                            <SelectBox
                                label={t("State")}
                                showLabel={true}
                                name="state_id"
                                register={register}
                                data={statesList}
                                loading={getStatesLoading}
                                placeholder={t("Choose State")}
                                required={true}
                                errors={errors}
                            />
                        </div>
                        <CheckboxField
                            name="active"
                            label="Activity"
                            register={register}
                            errors={errors}
                            defaultChecked={true}
                        />
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        {t('Close')}
                    </Button>
                    <SubmitButton
            isLoading={submitLoading}
            form="submit-form-update"
          />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default UpdateCityForm;
